import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const PinCodeOverview = lazy(() => import('../pin-code/pin-code-overview'));

export function PinCodeRoutes() {
    return (
        <Route path='pin-codes'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <PinCodeOverview />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
